import React from "react";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const nav = useNavigate();

  const token = JSON.parse(
    localStorage.getItem("userCredentials") || "{}"
  )?.accessToken;

  React.useEffect(() => {
    if (!token || token === undefined) {
      nav("/");
    }
  }, []);

  return (
    <div className="bg-white w-[100vw] h-[100vh]">
      <h1 className="text-center">Welcome to the dashboard</h1>
      <button
        className="mx-auto"
        onClick={() => {
          localStorage.removeItem("userCredentials");
          nav("/");
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default Dashboard;
